//登録フロー：メールアドレスパスワード認証用パスワード登録 /passwordRegister
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import { Link, browserHistory } from 'react-router'
import './css/passwordRegister.css';
import './css/toast_custom.css';
import ToggleDisplay from 'react-toggle-display';
import { createUserWithEmail } from './firebase';


export default class passwordRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordAgain: '',
      validationErrorMessage: '',
    }
  }

  handlePasswordAgainChange = (e) => {
    this.setState({ passwordAgain: e.target.value })
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value })
  }

  userRegister = async() => {
    const email = this.props.location.state.email;
    const password = this.state.password;
    const passwordAgain = this.state.passwordAgain;
    if (undefined === password || 0 === password.trim().length) {
      this.setState({ validationErrorMessage: '※パスワードを入力してください' })
      return;
    } else if (undefined === passwordAgain || 0 === passwordAgain.trim().length) {
      this.setState({ validationErrorMessage: '※確認用パスワードを入力してください' })
      return;
    } else if (password !== this.state.passwordAgain) {
      this.setState({ validationErrorMessage: '※パスワードが一致しません。再度入力してください' })
      return;
    } else if (!password.match(/[A-Z]/)) {
      // 大文字
      this.setState({ validationErrorMessage: '※最低１文字の英大文字を設定してください' });
      return;
    } else if (!password.match(/[a-z]/)) {
      // 小文字
      this.setState({ validationErrorMessage: '※最低１文字の英小文字を設定してください' });
      return;
    } else if (!password.match(/\d/)) {
      // 数字
      this.setState({ validationErrorMessage: '※最低１文字の数字を設定してください' });
      return;
    }

    try {
      await createUserWithEmail(email, password);
      browserHistory.push('/newflow3');
    } catch (err) {
      if ('auth/weak-password' === err.code) {
        this.setState({ validationErrorMessage: '※最低６文字で設定してください' });
        return;
      }
    }
  }


  render () {
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-password-register">
          {/* <Header parentProps={this.props} /> */}
          <Header />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <div className="block-password-register">
                    <h2 className="title">Sign Up</h2>
                    <img className="step_icon" src="/img/common/step-2@2x.png" alt="" />
                    <img className="title_icon" src="/img/common/m-key@2x.png" alt="" />
                    <div>
                      <p className="subtitle">パスワードを登録しよう！</p>
                      <p className="password-term">
                        パスワードは最低６文字、且つ１文字以上の大文字・小文字・数字を含む必要があります。
                      </p>
                      <form className="form-password">
                      <ToggleDisplay if={this.state.validationErrorMessage}>
                        {this.state.validationErrorMessage}
                      </ToggleDisplay>
                        <input type="password" placeholder="パスワードを入力ください" onChange={(e) => this.handlePasswordChange(e)}></input>
                        <input type="password" placeholder="パスワードを再度入力ください" onChange={(e) => this.handlePasswordAgainChange(e)}></input>
                      </form>
                      <div className="btnAction">
                        <Link onClick={this.userRegister} className="btn-connect">次へ</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/passwordRegister.js